
import { gsap } from "gsap";

export default function initLoader() {
    document.body.classList.add("PAGE-IS--LOADED");
    const loader = document.getElementById("app-loader");
    const headerLogo = document.querySelector("#app-header .custom-logo, #app-header .custom-logo-link img");
    if (headerLogo) {
        headerLogo.style.visibility = "visible";
        headerLogo.classList.remove("logo-hidden");
    }
    if (loader) {
        loader.addEventListener(
            "transitionend",
            () => {
                loader.remove();
            },
            { once: true }
        );
    }
}
